import React, { useState} from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import "./DashboardVentas.css";

const DashboardVentas = () => {
  const [productoId, setProductoId] = useState("");
  const [ventasData, setVentasData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);

  const obtenerVentasPorProducto = async () => {
    if (!productoId) return alert("Por favor, ingresa un ID de producto.");

    setLoading(true);
    setBusquedaRealizada(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/dashboard/ventas/`);
      const todasLasSucursales = response.data; 

      const ventasFiltradas = todasLasSucursales
        .flatMap((sucursal) => 
          sucursal.productos
            .filter((p) => p.producto_id === productoId)
            .flatMap((producto) => 
              producto.ventas.map((venta) => ({
                fecha: venta.fin,
                totalPiezas: venta.total_piezas,
                sucursal: sucursal.sucursal
              }))
            )
        );

      setVentasData(ventasFiltradas);
    } catch (error) {
      console.error("Error al obtener datos:", error);
      setVentasData([]);
    } finally {
      setLoading(false);
    }
  };

  
  const sortedVentas = ventasData.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

  
  const chartData = {
    labels: sortedVentas.map((item) => item.fecha.split("T")[0]),
    datasets: [
      {
        label: "Total de Ventas (Piezas)",
        data: sortedVentas.map((item) => item.totalPiezas),
        borderColor: "#007bff",
        backgroundColor: "rgba(0, 123, 255, 0.2)",
        pointBackgroundColor: "#007bff",
        pointBorderColor: "#fff",
        fill: true,
        tension: 0.3,
      },
    ],
  };

  return (
    <div className="dashboard-container">
      <h2>Dashboard de Ventas por Producto</h2>
      <div className="input-container">
        <input
          type="text"
          placeholder="ID de Producto"
          value={productoId}
          onChange={(e) => setProductoId(e.target.value)}
        />
        <button onClick={obtenerVentasPorProducto} disabled={loading}>
          {loading ? "Cargando..." : "Buscar"}
        </button>
      </div>

      {loading && <div className="loading-spinner"></div>}

      {busquedaRealizada && ventasData.length === 0 && !loading && (
        <p className="error-message">No se encontraron ventas para este producto.</p>
      )}

      {ventasData.length > 0 && !loading && (
        <div className="chart-container">
          <Line data={chartData} />
        </div>
      )}
    </div>
  );
};

export default DashboardVentas;
